const pad = (number: Number, numberOfZeros = 9) => number
    && new Array(numberOfZeros + 1).join('0').substring(0, numberOfZeros - String(number).length) + number;

export default pad;
